<div *ngIf="navEntries && navEntries.length > 0" class="main-nav-wrapper h-full" [ngClass]="{ 'mobile-nav': isMobile }" [attr.data-test-id]="'main-nav'">
  <nav #mainNav id="main-nav" class="main-nav h-full" i18n-aria-label aria-label="Main" tabindex="-1">
    <ul class="main-nav-list h-full level-0">
      <ng-template ngFor let-navEntry [ngForOf]="navEntries" let-i="index">
        <li
          class="main-nav-item"
          [ngClass]="{ expanded: navEntry.isExpanded, 'has-current': getHasCurrent(navEntry) }"
          [attr.data-test-id]="navEntry.testId"
          (pointerenter)="canHover && screenSizeDetectorService.isLargeScreen && onShowChildren(navEntry, $event)"
          (pointerleave)="canHover && screenSizeDetectorService.isLargeScreen && onHideChildren(navEntry, $event)"
          (keydown.esc)="onHideChildren(navEntry, $event)"
        >
          <span *ngIf="navEntry.testId === 'menu-items-li-Library'" tourAnchor="menu-items-li-Library.anchor" class="guided-tour-target absolute overlay-target"></span>
          <a
            *ngIf="navEntry.items?.length === 1 || (screenSizeDetectorService.isLargeScreen && canHover); else touchButton"
            [routerLink]="navEntry.items[0].routerLink"
            class="main-nav-link"
            (keydown.enter)="onShowChildren(navEntry, $event)"
            [attr.aria-current]="navEntry.items[0] ? getIsCurrent(navEntry.items[0]) : undefined"
          >
            {{ navEntry.text }}
            <mat-icon *ngIf="navEntry.items?.length && navEntry.items.length > 1" class="material-icons-outlined">chevron_right</mat-icon>
          </a>
          <ng-template #touchButton>
            <button
              class="main-nav-link"
              (click)="onToggleChildren(navEntry, $event)"
              [attr.aria-expanded]="navEntry.isExpanded"
              [attr.aria-controls]="navEntry.items.length && navEntry.items.length > 1 ? 'main-nav-sub-level-' + navEntry.menuId : ''"
            >
              {{ navEntry.text }}
              <mat-icon *ngIf="navEntry.items?.length && navEntry.items.length > 1" class="material-icons-outlined">chevron_right</mat-icon>
            </button>
          </ng-template>

          <div *ngIf="navEntry.items?.length && navEntry.items.length > 1" [id]="'main-nav-sub-level-' + navEntry.menuId" class="main-nav-sub-level level-1" [ngClass]="{ show: navEntry.isExpanded }">
            <ul class="main-nav-list level-1">
              <ng-template ngFor let-navItem [ngForOf]="navEntry.items" let-i="index">
                <li class="main-nav-item" [attr.data-test-id]="navItem.testId">
                  <span *ngIf="navItem.testId === 'menu-sub-items-overview'" tourAnchor="menu-items-li-assets.anchor" class="guided-tour-target absolute overlay-target"></span>
                  <span *ngIf="navItem.testId === 'menu-sub-items-collection'" tourAnchor="menu-items-li-collections.anchor" class="guided-tour-target absolute overlay-target"></span>
                  <a [routerLink]="navItem.routerLink" class="main-nav-link" [attr.aria-current]="getIsCurrent(navItem)">{{ navItem.text }}</a>
                </li>
              </ng-template>
            </ul>
          </div>
        </li>
      </ng-template>
    </ul>
  </nav>
</div>
